export default "__VITE_ASSET__CdqV6B$8__"